import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, unref as _unref, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createBlock as _createBlock, resolveDynamicComponent as _resolveDynamicComponent, Suspense as _Suspense, withCtx as _withCtx, normalizeStyle as _normalizeStyle, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-b84c886a"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "setup-shop" }
const _hoisted_2 = { key: 0 }
const _hoisted_3 = { class: "setup-title" }
const _hoisted_4 = { class: "setup-title-select" }
const _hoisted_5 = { key: 1 }
const _hoisted_6 = { class: "setup-title" }
const _hoisted_7 = { class: "setup-title-select" }
const _hoisted_8 = ["href"]
const _hoisted_9 = {
  key: 2,
  class: "setup-title"
}
const _hoisted_10 = ["href"]
const _hoisted_11 = {
  key: 3,
  class: "setup-title"
}

import { ref, computed, nextTick, onMounted, watch, Ref } from 'vue'
import { throttle } from 'lodash'
import setupHead from './components/setupHead.vue'
import SwitchRam from './components/SwitchRam.vue'
import ShopPurchase from './components/ShopPurchase.vue'
import ShopAddition from './components/ShopAddition.vue'
import ShopExpress from './components/ShopExpress.vue'
import ShopGroup from './components/ShopGroup.vue'
import setupUser from './SetupUser.vue'
import setupPwd from './SetupPwd.vue'
import SetupAdrs from './SetupAdrs.vue'
import ShopTax from './components/ShopTax.vue'
import { getSubCustomer } from '@/apis/user'
import { confirmEdit } from '@/util/useConfirm'
import { useRoute, useRouter } from 'vue-router'
import { useStore } from 'vuex'
import { isD2C, useSite, expressCostPdf, isEN, useSite2Station, isMultiStore } from '@/store'
import { t } from '@/plugins/i18n'
import { Site } from '@/common/const'
import ApiAuthSet from './components/ApiAuthSet.vue'
import ReceiptHeaderSetting from './components/ReceiptHeaderSetting.vue'
interface TABS {
  [key: string]: any
}


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const questionIcon = require('@/assets/image/icon/question-black-icon.png')
const site = useSite()

const route = useRoute()
const store = useStore()
const curshop = computed(() => store.getters.shopInfo)

const heightList = ref()

const hideTab = computed(() => route.meta.hideTab)
const { customerShopId, customerId } = route.query
const main = computed(() => store.getters.user)
const sub = ref([])
const accounts: any = computed(() => {
  return [main.value, ...sub.value]
})

// 国家商品，中国商品还是韩国商品，默认中国商品
const sourceCountry: Ref<'CN'| 'KR'> = ref('CN')
// 国家商品，中国商品还是韩国商品，默认中国商品
const logisticsSourceCountry: Ref<'CN'| 'KR'> = ref('CN')

const router = useRouter()
// 监听路由变化
watch(
  route,
  (v) => {
    const query = { ...v.query }
    if (!isMultiStore()) {
      sourceCountry.value = 'CN'
      return
    }
    // 做个兼容，只有为KRW展示韩元，否则字母拼错之类的一律默认CNY
    sourceCountry.value = query.sourceCountry === 'KR' ? 'KR' : 'CN'
  },
  { immediate: true }
)
// 更改附加项配置来源国家
const changeFundCountry = (val:'CN'| 'KR') => {
  sourceCountry.value = val
  const query = {
    ...route.query,
    sourceCountry: val
  }
  router.replace({ ...route, query })
}

const account = ref()
const update = () =>
  getSubCustomer().then((res) => {
    if (res.success) {
      sub.value = res.data
    }
  })

update().then(() => {
  account.value = customerId ?? store.getters.user.customerId
})

const suspenseRes = async (i: any) => {
  i.onload = true
}

const routeName = String(route.name).split('_')[0] || 'setupShop'

const tabsList: TABS = {
  setupShop: [
    { label: '采购配置', ctp: ShopPurchase, name: 'ShopPurchase', onload: false },
    { label: '发货设置', hidden: !isD2C(), ctp: ShopGroup, name: 'ShopGroup' },
    { label: t('API自动下单设定'), hidden: !(isD2C() && curshop.value.customerShopPlatform !== 7), ctp: ApiAuthSet, name: 'ApiAuthSet' },
    { label: '附加项配置', ctp: ShopAddition, name: 'ShopAddition' },
    { label: isD2C() ? '国际物流配置' : '国际发货', ctp: ShopExpress, name: 'ShopExpress' },
    { label: '我的地址', hidden: isD2C(), ctp: SetupAdrs, name: 'SetupAdrs' },
    { label: '扣税账号设置', hidden: (isD2C() || site !== 'ja'), ctp: ShopTax, name: 'ShopTax' },
    { label: '领受书抬头设定', hidden: site !== 'ja', ctp: ReceiptHeaderSetting, name: 'ReceiptHeaderSetting' }
  ],
  setupUser: [
    { label: '登录信息', ctp: setupUser, name: 'SetupUser', account: true },
    { label: '修改密码', ctp: setupPwd, name: 'SetupPwd', account: true }
  ]
}

const tabs = ref(tabsList[routeName].filter((v: any) => !v.hidden).fort())

const activeTab = ref(useRoute()?.query?.type ?? tabs.value[0].name)

const allLoaded = computed(() => tabs.value.every((i: any) => i.onload))
watch(() => allLoaded.value, () => {
  getHeight()
  setTimeout(() => {
    getHeight()
  }, 3000)
})

const getHeight = async () => {
  await nextTick()
  const heightCache = []
  for (const i in tabs.value) {
    if (tabs.value[i].name) {
      const v = document.querySelector(`.${tabs.value[i].name}Ref_setup`)?.getBoundingClientRect()
      v && heightCache.push({ top: v?.top, bottom: v?.bottom, name: tabs.value[i].name })
    }
  }
  heightList.value = heightCache
}

onMounted(() => {
  setTimeout(() => {
    getHeight()
  }, 2000)
})

// let timer: NodeJS.Timeout | null = null
// 是否阻止计算
const stopCal = ref(false)

const scroll = throttle(({ scrollTop }) => {
  if (heightList.value) {
    const target = heightList.value.filter((v: any) => {
      return v.top < scrollTop + 100 && v.bottom > scrollTop + 100
    })
    if (!stopCal.value) {
      target.length && (activeTab.value = target[0].name)
    }
  }
}, 16, { leading: false })

const realScroll = ref(({ scrollTop }: any) => {
  return scroll({ scrollTop })
})

const setupScroll = ref()

const tabClick = async (tab: any) => {
  (document.querySelector(`.${tab?.name}Ref_setup`) as HTMLElement)?.scrollIntoView({
    behavior: 'smooth',
    block: 'start',
    inline: 'nearest'
  })
  activeTab.value = tab.name
  stopCal.value = true
  setTimeout(() => {
    stopCal.value = false
  }, 2000)
}


return (_ctx: any,_cache: any) => {
  const _component_help_tooltip = _resolveComponent("help-tooltip")!
  const _component_el_scrollbar = _resolveComponent("el-scrollbar")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(setupHead, {
      tabs: tabs.value,
      activeTab: activeTab.value,
      "onUpdate:activeTab": _cache[0] || (_cache[0] = ($event: any) => ((activeTab).value = $event)),
      onTabClick: tabClick
    }, null, 8, ["tabs", "activeTab"]),
    _createVNode(_component_el_scrollbar, {
      class: "fx-1 user-scroll-container pb_60",
      onScroll: realScroll.value,
      ref: (_value, _refs) => {
        _refs['setupScroll'] = _value
        setupScroll.value = _value
      }
    }, {
      default: _withCtx(() => [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(tabs.value, (i) => {
          return (_openBlock(), _createElementBlock("div", {
            key: i.name,
            class: _normalizeClass(`${i.name}Ref_setup setup-block`)
          }, [
            (i.name === 'ShopAddition' && _unref(isMultiStore)())
              ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                  _createElementVNode("div", _hoisted_3, [
                    _createTextVNode(_toDisplayString(_unref(t)(i.label)) + " ", 1),
                    _createElementVNode("div", _hoisted_4, [
                      _createElementVNode("div", {
                        onClick: _cache[1] || (_cache[1] = ($event: any) => {changeFundCountry('CN');}),
                        class: _normalizeClass(`title-select-cn ${sourceCountry.value === 'CN'? 'title-select-active':''}`)
                      }, _toDisplayString(_unref(t)('中国商品')), 3),
                      _createElementVNode("div", {
                        onClick: _cache[2] || (_cache[2] = ($event: any) => (changeFundCountry('KR'))),
                        class: _normalizeClass(`title-select-kr ${sourceCountry.value === 'KR'? 'title-select-active':''}`)
                      }, _toDisplayString(_unref(t)('韩国商品')), 3)
                    ])
                  ])
                ]))
              : (i.name === 'ShopExpress' && _unref(isMultiStore)() && _unref(isD2C)())
                ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                    _createElementVNode("div", _hoisted_6, [
                      _createTextVNode(_toDisplayString(_unref(t)(i.label)) + " ", 1),
                      _createElementVNode("div", _hoisted_7, [
                        _createElementVNode("div", {
                          onClick: _cache[3] || (_cache[3] = ($event: any) => (logisticsSourceCountry.value = 'CN')),
                          class: _normalizeClass(`title-select-cn ${logisticsSourceCountry.value === 'CN'? 'title-select-active':''}`)
                        }, _toDisplayString(_unref(t)('中国商品')), 3),
                        _createElementVNode("div", {
                          onClick: _cache[4] || (_cache[4] = ($event: any) => (logisticsSourceCountry.value = 'KR')),
                          class: _normalizeClass(`title-select-kr ${logisticsSourceCountry.value === 'KR'? 'title-select-active':''}`)
                        }, _toDisplayString(_unref(t)('韩国商品')), 3)
                      ])
                    ]),
                    (i.name === 'ShopExpress' && logisticsSourceCountry.value!=='KR')
                      ? (_openBlock(), _createElementBlock("a", {
                          key: 0,
                          style: {"margin-top":"8px","margin-bottom":"8px"},
                          class: _normalizeClass(["light rel flex-ter", _unref(useSite)()]),
                          target: "_blank",
                          href: _unref(expressCostPdf)()
                        }, [
                          _createTextVNode(_toDisplayString(_unref(t)('国际料金表')) + ">", 1),
                          (_unref(isEN)())
                            ? (_openBlock(), _createBlock(_component_help_tooltip, {
                                key: 0,
                                tip: "The shipping list for reference only, final cost will according to the package info.",
                                icon: _unref(questionIcon)
                              }, null, 8, ["icon"]))
                            : _createCommentVNode("", true)
                        ], 10, _hoisted_8))
                      : _createCommentVNode("", true)
                  ]))
                : (i.name === 'ShopExpress')
                  ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                      _createTextVNode(_toDisplayString(_unref(t)(i.label)), 1),
                      (!_unref(isMultiStore)())
                        ? (_openBlock(), _createElementBlock("a", {
                            key: 0,
                            class: _normalizeClass(["light rel flex-ter", _unref(useSite)()]),
                            target: "_blank",
                            href: _unref(expressCostPdf)()
                          }, [
                            _createTextVNode(_toDisplayString(_unref(t)('国际料金表')) + ">", 1),
                            (_unref(isEN)())
                              ? (_openBlock(), _createBlock(_component_help_tooltip, {
                                  key: 0,
                                  tip: "The shipping list for reference only, final cost will according to the package info.",
                                  icon: _unref(questionIcon)
                                }, null, 8, ["icon"]))
                              : _createCommentVNode("", true)
                          ], 10, _hoisted_10))
                        : _createCommentVNode("", true)
                    ]))
                  : (_openBlock(), _createElementBlock("div", _hoisted_11, _toDisplayString(_unref(t)(i.label)), 1)),
            (_openBlock(), _createBlock(_Suspense, {
              onResolve: ($event: any) => (suspenseRes(i))
            }, {
              default: _withCtx(() => [
                (!i.account || account.value)
                  ? (_openBlock(), _createBlock(_resolveDynamicComponent(i.ctp), {
                      sourceCountry: sourceCountry.value,
                      logisticsSourceCountry: logisticsSourceCountry.value,
                      key: i.name,
                      customer: _unref(accounts).find((v) => v.customerId === account.value),
                      onUpdate: update
                    }, null, 8, ["sourceCountry", "logisticsSourceCountry", "customer"]))
                  : _createCommentVNode("", true)
              ]),
              _: 2
            }, 1032, ["onResolve"]))
          ], 2))
        }), 128)),
        _createElementVNode("div", {
          style: _normalizeStyle({ height: _unref(isD2C)() ? '250px' : '350px' })
        }, null, 4)
      ]),
      _: 1
    }, 8, ["onScroll"])
  ]))
}
}

})